import { getStatusForId } from '@ms/yammer-data-support';

import type { FeatureTranslation, Translations, YammerI18nState } from '../../state/types';
import { getCurrentLocale, getPreviousLocale } from '../locales/selectors';

import { getFeatureTranslationKey } from './shared';

export const getTranslations: (state: YammerI18nState) => Translations = (state) => state.i18n.translations;

const getFullfilledTranslations = (state: YammerI18nState): Record<string, FeatureTranslation> =>
  getTranslations(state).fulfilled.byId;

type HaveFeatureTranslationsBeenRequested = (state: YammerI18nState, feature: string) => boolean;
export const haveFeatureTranslationsBeenRequested: HaveFeatureTranslationsBeenRequested = (state, feature) => {
  const currentLocale = getCurrentLocale(state);
  const featureId = getFeatureTranslationKey(currentLocale, feature);
  const status = getStatusForId(getTranslations(state), featureId);

  return status !== 'notRequested';
};

type HaveFeatureTranslationsCompleted = (state: YammerI18nState, feature: string) => boolean;
export const haveFeatureTranslationsCompleted: HaveFeatureTranslationsCompleted = (state, feature) => {
  const currentLocale = getCurrentLocale(state);
  const featureId = getFeatureTranslationKey(currentLocale, feature);
  const status = getStatusForId(getTranslations(state), featureId);

  return status === 'fulfilled' || status === 'rejected';
};

const defaultRawTranslations: Record<string, string> = {};

export const getTranslationDataForFeature = (state: YammerI18nState, feature: string): Record<string, string> => {
  const translations = getFullfilledTranslations(state);
  const currentLocale = getCurrentLocale(state);
  const previousLocale = getPreviousLocale(state);

  const featureTranslations =
    translations[getFeatureTranslationKey(currentLocale, feature)] ||
    translations[getFeatureTranslationKey(previousLocale, feature)];

  return featureTranslations ? featureTranslations.strings : defaultRawTranslations;
};
